@if (_rule.ruleType == 'metrics' || _rule.ruleType == 'field-metrics' || _rule.ruleType == null) {
  <span class="font-weight-normal conditions d-inline-block" [class.editing]="_rule.editing">

    <div class="position-relative">

      @if (alertHistory) {
        <span class="condition-text nav-font14 grey5 position-relative font-weight-bold mr-1">If a project where</span>
      }

      <!-- Scope Type -->
      <ng-template *ngTemplateOutlet="tplScopeType"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative mx-1 font-weight-bold">  has a(an)  </span>

      <!-- Metrics -->
      <ng-template *ngTemplateOutlet="tplMetrics"></ng-template>

      <!-- Different message for when LOI, IR, ManualQCs -->
      @if (selectedMetric === 'LOI' || selectedMetric === 'IR' || selectedMetric === 'Manual QCs') {

        <!-- Metric number -->
        <ng-template *ngTemplateOutlet="tplMetricNumber"></ng-template>

        <!-- Operators -->
        <ng-template *ngTemplateOutlet="tplOperators"></ng-template>

        <span class="condition-text nav-font14 grey5 position-relative mr-1 font-weight-bold"> the project threshold,</span>
        <span class="condition-text nav-font14 grey5 position-relative mr-1 font-weight-bold"> Notify Me via</span>

      }@else if (selectedMetric === 'Nav OQs') {

        <span class="condition-text nav-font14 grey5 position-relative mr-1 font-weight-bold"> , Notify Me via</span>

      }@else {

        <!-- Operators -->
        <ng-template *ngTemplateOutlet="tplOperators"></ng-template>

        <!-- Metric number -->
        <ng-template *ngTemplateOutlet="tplMetricNumber"></ng-template>

        <span class="condition-text nav-font14 grey5 position-relative mr-1 font-weight-bold"> , Notify Me via</span>
      }

      <!-- Method -->
      <ng-template *ngTemplateOutlet="tplAlertMethod"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative font-weight-bold">.  </span>

    </div>
  </span>
}

@if (_rule.ruleType == 'tasks') {

  <span class="font-weight-normal conditions d-inline-block" [class.editing]="_rule.editing">

    <div class="position-relative">

      @if (alertHistory) {
        <span class="condition-text nav-font14 grey5 position-relative font-weight-bold mr-1">Notify Me via</span>
      }

      <!-- Method -->
      <ng-template *ngTemplateOutlet="tplAlertMethod"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative ml-1 font-weight-bold">  if a task is </span>

      <!-- Metrics -->
      <ng-template *ngTemplateOutlet="tplMetrics"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative font-weight-bold">.  </span>

    </div>

  </span>
}

@if (_rule.ruleType == 'past-due') {

  <span class="font-weight-normal conditions d-inline-block" [class.editing]="_rule.editing">

    <div class="position-relative">

      @if (alertHistory) {
        <span class="condition-text nav-font14 grey5 position-relative font-weight-bold mr-1">Notify</span>
      }

      <!-- Recipient -->
      <ng-template *ngTemplateOutlet="tplAlertRecipient"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative font-weight-bold">  via  </span>

      <!-- Method -->
      <ng-template *ngTemplateOutlet="tplAlertMethod"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative mx-1 font-weight-bold">  when the field end date of </span>

      <!-- Scope Type -->
      <ng-template *ngTemplateOutlet="tplScopeType"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative font-weight-bold mx-1"> is past due and survey is still fielding.  </span>

    </div>

  </span>
}

@if (_rule.ruleType == 'survey-activity') {

  <span class="font-weight-normal conditions d-inline-block" [class.editing]="_rule.editing">

    <div class="position-relative">

      @if (alertHistory) {
        <span class="condition-text nav-font14 grey5 position-relative font-weight-bold mr-1">Notify</span>
      }

      <!-- Recipient(s) -->
      <ng-template *ngTemplateOutlet="tplAlertRecipient"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative font-weight-bold"> via </span>

      <!-- Method -->
      <ng-template *ngTemplateOutlet="tplAlertMethod"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative font-weight-bold"> if the status of one of </span>

      <!-- Scope / Group -->
      <ng-template *ngTemplateOutlet="tplScopeType"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative font-weight-bold"> is </span>

      <!-- Survey Status (multi-select) -->
      <ng-template *ngTemplateOutlet="tplSurveyStatus"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative font-weight-bold"> and it has not received any </span>

      <!-- Respondent Status -->
      <ng-template *ngTemplateOutlet="tplRespondentStatus"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative font-weight-bold"> in </span>

      <!-- Days -->
      <ng-template *ngTemplateOutlet="tplDaysInactive"></ng-template>

      <span class="condition-text nav-font14 grey5 position-relative font-weight-bold"> day(s). </span>

    </div>

  </span>
}

<!-- Template for Alert Method Dropdown -->
<ng-template #tplAlertMethod>
  @if (!_rule.editing) {
    <span class="condition-field d-inline-block clickable" style="max-width: 260px;" >{{ selectedAlertMethodLabel }}</span>
  }

  @if (_rule.editing) {
    <div class="dropdown alertMethod condition-field d-inline-block clickable" dropdown #ddAlertMethod="bs-dropdown" [insideClick]="true" container="body" [isDisabled]="!_rule.editing" [class.open]="ddAlertMethod.isOpen">
      <div dropdownToggle class="cursor-pointer w-100 position-relative d-flex align-items-center clickable">
        <span class="pr-4 nav-font14 my-1 d-flex-inline text-truncate clickable"
            [tooltip]="selectedAlertMethod === 'Select method' ? '' : selectedAlertMethod"
            [ngClass]="selectedAlertMethod === 'Select method' ? 'grey3' : 'grey5'">{{ selectedAlertMethod }}
        </span>
        <i class="fak fa-down-arrow fa-xs ml-auto grey4" [class.fa-rotate-180]="ddAlertMethod.isOpen"></i>
      </div>
      <ul *dropdownMenu class="dropdown-menu dropdown-method nav-font14 py-0" role="menu">
        @for (method of alertMethods; track method; let i = $index) {
          <li role="menuitem" class="mx-1 my-1 clickable">
            <a class="dropdown-item px-1 pt-1 d-flex clickable" [class.border-bottom]="(i+1) < alertMethods?.length">
                <div class="or-checkbox pl-0 pr-0 d-flex justify-content-start col-1 clickable">
                  <input type="checkbox"
                    [name]="'chkMethod' + i"
                    [id]="'chkMethod' + i"
                    [checked]="isMethodSelected(method)"
                    (change)="applyAlertMethod(method, $event.target.checked)">
                  <label [for]="'chkMethod' + i"></label>
                  <small class="pl-4 grey5 nav-font14">{{method}}</small>
                </div>
            </a>
          </li>
        }
      </ul>
    </div>
  }
</ng-template>

<!-- Template for ScopeType Dropdown -->
<ng-template #tplScopeType>
  @if (!_rule.editing) {
    <span class="condition-field d-inline-block" style="max-width: 260px;" >
      {{ selectedScope }}
    </span>
  }

  @if (_rule.editing) {
    <div class="dropdown alertScopeType condition-field d-inline-block" dropdown #ddScope="bs-dropdown" container="body" [isDisabled]="!_rule.editing" [class.open]="ddScope.isOpen">
      <div dropdownToggle class="cursor-pointer w-100 position-relative d-flex align-items-center">
        <span class="pr-4 nav-font14 my-1 d-flex-inline text-truncate" [ngClass]="selectedScope === 'Select group' ? 'grey3' : 'grey5'">{{ selectedScope }}</span>
        <i class="fak fa-down-arrow fa-xs ml-auto grey4" [class.fa-rotate-180]="ddScope.isOpen"></i>
      </div>
      <ul *dropdownMenu class="dropdown-menu dropdown-scope nav-font14 py-0 scrollbar overflow-y" role="menu">
        @for (scope of scopeTypes; track scope) {
          <li role="menuitem" class="mx-1 my-1 cursor-pointer">
            <a class="dropdown-item px-1 pt-2 border-bottom cursor-pointer d-flex" [class.border-bottom]="($index+1) < scopeTypes?.length" (click)="applyScope(scope)">{{scope.label}}</a>
          </li>
        }
      </ul>
    </div>
  }
</ng-template>

<!-- Template for Metrics Dropdown -->
<ng-template #tplMetrics>
  @if (!_rule.editing) {
    <span class="condition-field d-inline-block" style="max-width: 260px;" >
      {{ selectedMetric }}
    </span>
  }

  @if (_rule.editing) {
    <div class="dropdown alertMetric condition-field d-inline-block ml-1" dropdown #ddMetric="bs-dropdown" container="body" [isDisabled]="!_rule.editing" [class.open]="ddMetric.isOpen">
      <div dropdownToggle class="cursor-pointer w-100 position-relative d-flex align-items-center">
        <span class="pr-4 nav-font14 my-1 d-flex-inline text-truncate" [ngClass]="selectedMetric === 'Select metric' || selectedMetric === 'Select' ? 'grey3' : 'grey5'">{{ selectedMetric }}</span>
        <i class="fak fa-down-arrow fa-xs ml-auto grey4" [class.fa-rotate-180]="ddMetric.isOpen"></i>
      </div>
      <ul *dropdownMenu class="dropdown-menu dropdown-metrics nav-font14 py-0" role="menu">
        @for (metric of metricTypes; track metric) {
          @if (metric != 'Quota cells' || _rule?.scopeType === 'Project') {
            <li role="menuitem" class="mx-1 my-1 cursor-pointer">
              <a class="dropdown-item px-1 pt-2 cursor-pointer d-flex" [class.border-bottom]="($index+1) < metricTypes?.length" (click)="applyMetric(metric)">{{metric.label}}</a>
            </li>
          }
        }
      </ul>
    </div>
  }
</ng-template>

<!-- Template for Operators Dropdown -->
<ng-template #tplOperators>
  @if (selectedMetric === 'Quota cells') {
    <span class="condition-text nav-font14 grey5 position-relative ml-2 font-weight-bold">have reached</span>
  }
  @else {
    @if (!_rule.editing) {
      <span class="condition-field d-inline-block ml-1" style="max-width: 260px;" >
        {{ selectedOperator }}
      </span>
    }

    @if (_rule.editing) {
      <div class="dropdown alertOperators mx-2 condition-field d-inline-block" dropdown #ddOperator="bs-dropdown" container="body" [isDisabled]="!_rule.editing" [class.open]="ddOperator.isOpen">
        <div dropdownToggle class="cursor-pointer w-100 position-relative d-flex align-items-center">
          <span class="pr-4 nav-font14 my-1 d-flex-inline text-truncate" [ngClass]="selectedOperator === 'Select' ? 'grey3' : 'grey5'">{{ selectedOperator }}</span>
          <i class="fak fa-down-arrow fa-xs ml-auto grey4" [class.fa-rotate-180]="ddOperator.isOpen"></i>
        </div>
        <ul *dropdownMenu class="dropdown-menu dropdown-operators nav-font14 py-0" role="menu">
          @for (operator of operators; track operator) {
            <li role="menuitem" class="mx-1 my-1 cursor-pointer">
              <a class="dropdown-item px-1 pt-2 border-bottom cursor-pointer d-flex" [class.border-bottom]="($index+1) < operators?.length" (click)="applyOperator(operator)">{{operator.label}}</a>
            </li>
          }
        </ul>
      </div>
    }
  }
</ng-template>

<!-- Template for Metric number-->
<ng-template #tplMetricNumber>
  @if (selectedMetric === 'Quota cells') {
    <span class="condition-text nav-font14 grey5 position-relative mr-2 font-weight-bold"> their limit</span>
  }
  @else {
    <span class="condition-field ml-1" [class.editable]="_rule.editing">
      @if (!_rule.editing) {
        <span class="condition-field d-inline-block" style="max-width: 260px;">{{selectedMetricNumber.label}}@if (selectedMetricNumber.label > -1){{{selectedMetricNumber.suffix}}}</span>
      }
      @if (_rule.editing) {
        <div class="d-inline-block metric-number">
          <div class="input-group">
            <input type="text" mask="99999"
            [patterns]="integerPattern"
            [(ngModel)]="selectedMetricNumber.label"
            (input)="handleFields('number');"
            (blur)="handleFields('number');"
            (focus)="$event.target.select()"
            class="form-control form-control-nav form-control-sm d-inline text-right">
            <div class="input-group-append d-flex align-items-center border pr-2">
              <span class="bg-white font-weight-normal cursor-default">{{selectedMetricNumber.suffix}}</span>
            </div>
          </div>
        </div>
      }
    </span>
  }

</ng-template>


<!-- Template for Survey Status (multi-select, survey-activity only) -->
<ng-template #tplSurveyStatus>
  @if (!_rule.editing) {
    <span class="condition-field d-inline-block" style="max-width: 260px;">{{ selectedSurveyStatusLabel }}</span>
  }
  @if (_rule.editing) {
    <div class="dropdown alertMethod condition-field d-inline-block clickable" dropdown #ddSurveyStatus="bs-dropdown" [insideClick]="true" container="body" [isDisabled]="!_rule.editing" [class.open]="ddSurveyStatus.isOpen">
      <div dropdownToggle class="cursor-pointer w-100 position-relative d-flex align-items-center clickable">
        <span class="pr-4 nav-font14 my-1 d-flex-inline text-truncate clickable"
            [ngClass]="selectedSurveyStatuses.length === 0 ? 'grey3' : 'grey5'">{{ selectedSurveyStatusLabel }}</span>
        <i class="fak fa-down-arrow fa-xs ml-auto grey4" [class.fa-rotate-180]="ddSurveyStatus.isOpen"></i>
      </div>
      <ul *dropdownMenu class="dropdown-menu dropdown-method nav-font14 py-0" role="menu">
        @for (status of surveyStatusOptions; track status; let i = $index) {
          <li role="menuitem" class="mx-1 my-1 clickable">
            <a class="dropdown-item px-1 pt-1 d-flex clickable" [class.border-bottom]="(i + 1) < surveyStatusOptions?.length">
              <div class="or-checkbox pl-0 pr-0 d-flex justify-content-start col-1 clickable">
                <input type="checkbox"
                  [name]="'chkSurveyStatus' + i"
                  [id]="'chkSurveyStatus' + i"
                  [checked]="isSurveyStatusSelected(status.type)"
                  (change)="applySurveyStatus(status, $event.target.checked)">
                <label [for]="'chkSurveyStatus' + i"></label>
                <small class="pl-4 grey5 nav-font14 clickable">{{ status.label }}</small>
              </div>
            </a>
          </li>
        }
      </ul>
    </div>
  }
</ng-template>

<!-- Template for Respondent Status (single-select, survey-activity only) -->
<ng-template #tplRespondentStatus>
  @if (!_rule.editing) {
    <span class="condition-field d-inline-block" style="max-width: 260px;">{{ selectedRespondentStatus }}</span>
  }
  @if (_rule.editing) {
    <div class="dropdown alertRespondentStatus condition-field d-inline-block ml-1" dropdown #ddRespondentStatus="bs-dropdown" container="body" [isDisabled]="!_rule.editing" [class.open]="ddRespondentStatus.isOpen">
      <div dropdownToggle class="cursor-pointer w-100 position-relative d-flex align-items-center">
        <span class="pr-4 nav-font14 my-1 d-flex-inline text-truncate"
            [tooltip]="selectedRespondentStatus !== 'Select respondent status' ? selectedRespondentStatus : ''"
            placement="top"
            [ngClass]="selectedRespondentStatus === 'Select respondent status' ? 'grey3' : 'grey5'">{{ selectedRespondentStatus }}</span>
        <i class="fak fa-down-arrow fa-xs ml-auto grey4" [class.fa-rotate-180]="ddRespondentStatus.isOpen"></i>
      </div>
      <ul *dropdownMenu class="dropdown-menu dropdown-metrics nav-font14 py-0" role="menu">
        @for (status of respondentStatusOptions; track status) {
          <li role="menuitem" class="mx-1 my-1 cursor-pointer">
            <a class="dropdown-item px-1 pt-2 cursor-pointer d-flex"
              [class.border-bottom]="($index + 1) < respondentStatusOptions?.length"
              (click)="applyRespondentStatus(status); ddRespondentStatus.hide()">{{ status.label }}</a>
          </li>
        }
      </ul>
    </div>
  }
</ng-template>

<!-- Template for Days Inactive (numeric input, survey-activity only) -->
<ng-template #tplDaysInactive>
  @if (!_rule.editing) {
    <span class="condition-field d-inline-block" style="max-width: 80px;">{{ selectedDays }}</span>
  }
  @if (_rule.editing) {
    <span class="condition-field ml-1" [class.editable]="_rule.editing">
      <div class="d-inline-block">
        <input type="text" mask="99999"
          [patterns]="integerPattern"
          [(ngModel)]="selectedDays"
          (input)="applyDaysInactive()"
          (blur)="applyDaysInactive()"
          (focus)="$event.target.select()"
          style="width: 65px;"
          class="form-control form-control-nav form-control-sm d-inline text-right">
      </div>
    </span>
  }
</ng-template>

<!-- Templates for Alert Recipient Dropdown -->
  <ng-template #tplAlertRecipient>

    @if (!_rule.editing) {
      <span class="condition-field d-inline-block text-nowrap">
        {{ _rule.ruleActions[0].alertRecipientType.replaceAll(',', ', ') }}
      </span>
    }

    <!-- Adding or Editing -->
    @if (_rule.editing) {
      <div class="d-inline-block clickable">
        @for (recipient of listRecipients; track recipient; let i = $index) {
          <div class="dropdown alertRecipient condition-field d-inline-block mr-1 clickable" dropdown #ddAlertRecipient="bs-dropdown" container="body" [insideClick]="true"
            [isDisabled]="!_rule.editing" [class.open]="ddAlertRecipient.isOpen">
            <div dropdownToggle class="cursor-pointer w-100 position-relative d-flex align-items-center clickable">

              @if (recipient?.value === 'Select user') {
                <i class="fa fa-xmark mr-auto grey4 fa-sm font-weight-normal position-relative clickable" [style]="!ddAlertRecipient.isOpen ? 'top:1px' : ''"
                [class.fa-rotate-180]="ddAlertRecipient.isOpen" [class.d-none]="i===0" (click)="removeNewRecipient(i)"></i>
              }

              <span class="pr-4 nav-font14 my-1 d-flex-inline selectedAlertRecipient text-truncate clickable"
                  [tooltip]="recipient?.type === 'email' ? recipient.label : ''"
                  [ngClass]="recipient?.value === 'Select user' ? 'grey3' : 'grey5'">
                {{ recipient?.value }}
              </span>

              @if (recipient?.value === 'Select user') {
                <i class="fak fa-down-arrow fa-xs ml-auto grey4 clickable" [class.fa-rotate-180]="ddAlertRecipient.isOpen"></i>
              } @else {
                <i class="fa fa-xmark ml-auto grey4 fa-sm font-weight-normal clickable" (click)="removeNewRecipient(i)"></i>
              }

            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-recipient nav-font14 py-0" role="menu">
              @for (option of recipient.options; track option ) {
                <li role="menuitem" class="mx-1 my-1 cursor-pointer clickable">
                  <a class="dropdown-item px-1 pt-2 cursor-pointer d-block text-truncate clickable"
                    [class.border-bottom]="($index+1) < recipient?.options?.length"
                    container="body"
                    [tooltip]="option?.label.includes('@') ? option?.label : ''"
                     (click)="applyAlertRecipient(recipient, option); ddAlertRecipient.hide()">
                    {{ option?.label }}
                  </a>
                </li>
              }

              <!-- <li role="menuitem" class="mx-1 my-1 cursor-pointer clickable" [class.d-none]="!addingEmail">
                <a class="dropdown-item recipientEmail px-1 clickable">
                  <div class="row">
                    <div class="col">
                      <span class="d-block nav-font12 grey4 mb-2 clickable">Type e-mail and click 'Add'</span>
                      <textarea [autosize]="false" rows="2" [(ngModel)]="newRecipient" (keyup)="checkEmail($event);" class="form-control form-control-sm form-control-nav nav-font12 clickable" placeholder="email@address.com"></textarea>
                      <div class="mt-2 d-flex justify-content-end clickable">
                        <button class="btn btn-sm nav-btn-primary mx-2 shadow-none font-weight-bold mr-2 clickable" (click)="cancelRecipientEmail()">Cancel</button>
                        <button
                          class="btn shadow-none font-weight-bold nav-font14 pb-1 clickable"
                          [ngClass]="!emailValidator.valid ? 'nav-btn-disabled' : 'nav-btn-accent'"
                          [disabled]="!emailValidator.valid"
                          (click)="addNewRecipientEmail(i); ddAlertRecipient.hide()">Add
                        </button>
                      </div>
                    </div>
                  </div>
                </a>
              </li> -->
              <!-- <li role="menuitem" class="mx-1 my-1 cursor-pointer clickable" [class.d-none]="addingEmail">
                <a class="dropdown-item px-1 clickable">
                  <div class="col d-flex align-items-center px-0 nav-accent-blue clickable" (click)="addingEmail=true">
                    <i class="far fa-plus pr-2 clickable"></i>
                    <span class="font-weight-bold clickable">Add e-mail</span>
                  </div>
                </a>
              </li> -->
            </ul>
          </div>
        }

        <span class="nav-font14 font-weight-bold d-inline-flex align-items-center mr-2 clickable position-relative" style="top:1px"
            [ngClass]="!canAddNewRecipient ? 'grey2' : 'nav-accent-blue cursor-pointer'"
            (click)="!canAddNewRecipient ? null: addNewRecipient()"
            [attr.disabled]="!canAddNewRecipient ? true : null">
          <i class="fak fa-plus fa-xl mx-2"></i> Add user
        </span>

      </div>
    }
  </ng-template>


